import React from 'react';
import { Popup } from './Popup';
import PrimaryButton from '../Button/PrimaryButton';

interface SecurityWarningPopupProps {
  visible: boolean;
  onClose: () => void;
}

const Highlight: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <strong className="font-bold text-[#F15B5B]">{children}</strong>
);

export const SecurityWarningPopup: React.FC<SecurityWarningPopupProps> = ({
  visible,
  onClose,
}) => {
  return (
    <Popup
      visible={visible}
      onCancel={onClose}
      title={
        <span className="font-bold text-[#2A2A2A]">
          ⚠ CẢNH BÁO AN TOÀN
        </span>
      }
      footer={
        <div className="flex justify-end w-full">
          <PrimaryButton
            fullWidth={false}
            className="px-6 min-w-[140px]"
            onClick={onClose}
          >
            Tôi đã hiểu
          </PrimaryButton>
        </div>
      }
      maskClosable={false}
      width={560}
      className="security-warning-popup"
    >
      <div className="text-sm text-[#2C3131] leading-relaxed space-y-4 max-h-[60vh] overflow-y-auto pr-1">
        <div>
          <p className="font-bold mb-1">1. Quản lý tài khoản Telegram</p>
          <ul className="list-none space-y-1 pl-0">
            <li>
              - Tuyệt đối không click vào bất kỳ đường link nào trên Telegram yêu cầu
              xác thực, đăng nhập hoặc cung cấp thông tin tài khoản.
            </li>
            <li>
              - Thường xuyên kiểm tra các thiết bị đang đăng nhập Telegram và{' '}
              <Highlight>đăng xuất ngay các thiết bị lạ hoặc không còn sử dụng</Highlight>{' '}
              để tránh nguy cơ bị chiếm đoạt hoặc theo dõi tài khoản.
            </li>
          </ul>
        </div>

        <div>
          <p className="font-bold mb-1">2. Nạp/rút tiền</p>
          <ul className="list-none space-y-1 pl-0">
            <li>
              - Chỉ chuyển tiền theo{' '}
              <Highlight>mã QR được sinh trực tiếp từ hệ thống giao dịch</Highlight>, đúng
              thông tin tài khoản đã được xác thực.
            </li>
            <li>
              - Tuyệt đối không chuyển tiền vào bất kỳ tài khoản nào khác với các lý do
              như: hệ thống lỗi, tài khoản ngân hàng lỗi, cần đổi tài khoản nhận tiền hoặc
              bất kỳ lý do tương tự.
            </li>
            <li>
              - Không thực hiện theo hướng dẫn của bất kỳ cá nhân nào,{' '}
              <Highlight>kể cả DVKH hoặc CTV</Highlight>, liên quan đến việc thay đổi tài
              khoản nhận tiền, cung cấp đường link xác thực, mã OTP hoặc phương thức chuyển
              tiền.
            </li>
          </ul>
        </div>

        <div>
          <p className="font-bold mb-1">3. Phương thức trao đổi thông tin</p>
          <ul className="list-none space-y-1 pl-0">
            <li>
              - Các thông báo chính thức được thực hiện trên{' '}
              <Highlight>website hoặc webapp</Highlight>.
            </li>
            <li>
              - <Highlight>Telegram chỉ là kênh thông báo bổ sung</Highlight> và không thay
              thế thông tin chính thức trên hệ thống.
            </li>
          </ul>
        </div>

        <div>
          <p className="font-bold mb-1">4. Khi có thông tin bất thường</p>
          <ul className="list-none space-y-1 pl-0">
            <li>
              - Khi nhận được bất kỳ yêu cầu thông tin bất thường nào,{' '}
              <Highlight>dừng ngay giao dịch/chuyển tiền</Highlight> và liên hệ trực tiếp
              với <Highlight>Ngân - 0976.428.986</Highlight> để xác minh trước khi thực hiện.
            </li>
            <li>
              -{' '}
              <Highlight>
                Không cung cấp mật khẩu, mã OTP hoặc thông tin xác thực tài khoản
              </Highlight>{' '}
              cho bất kỳ cá nhân nào dưới bất kỳ hình thức nào.
            </li>
          </ul>
        </div>
      </div>
    </Popup>
  );
};

export default SecurityWarningPopup;
